import axios, { AxiosResponse } from "axios";
import {
  ApiResponseGetItemDetails,
  ApiResponseGetPastOrderCustomerData,
  ApiResponseGetPaymentLink,
  ApiResponseGetRecommendedItems,
  ApiResponseGetSchoolDetails,
  ApiResponseGetStoreItems,
  DataLinks,
  DefaultAndRecommendedItem,
  FinancialData,
  ItemDetailsData,
  PaymentLink,
  RecommendedItem,
  SchoolDetails,
  getAvailableDatesForExamResponse,
  getOrderStatusResponse,
} from "../DefinitionsInterfaces";
import * as Sentry from "@sentry/react";
import api from "../axios/axiosMW";

const fetchItemsList = async (): Promise<void> => {
  try {
    const response: AxiosResponse<ApiResponseGetStoreItems> = await api.post(
      "/get-store-items",
      {},
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    console.log("Response = ", response);
    if (
      response &&
      response.status === 200 &&
      response.data &&
      response.data.status_code === 200 &&
      response.data.data
    ) {
      console.log("ItemsObtains");
    } else {
      throw new Error("Invalid response for student search");
    }
  } catch (error) {
    console.log("API failed with error : ", error);
  }
};

export const fetchItemDetails = async (
  itemId: number
): Promise<ItemDetailsData[]> => {
  let foundItems: ItemDetailsData[] = [];
  try {
    const response: AxiosResponse<ApiResponseGetItemDetails> = await api.post(
      "/get-details-for-item",
      {
        itemID: itemId,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    console.log("Response = ", response);
    if (
      response &&
      response.status === 200 &&
      response.data &&
      response.data.status_code === 200 &&
      response.data.data
    ) {
      foundItems.push(response.data.data);
      // setCheckoutItems(response.data.data.items);
    } else {
      throw new Error("Invalid response for student search");
    }
  } catch (error) {
    throw new Error(`API failed with error : ${error}`);
  }
  return foundItems;
};

export const getSchoolByCode = async (
  schoolCode: string
): Promise<SchoolDetails> => {
  let schoolDetails: SchoolDetails = {
    schoolID: 0,
    schoolName: "",
    linkActive: false,
    city: "",
    state: "",
    individual_registration: false,
    examDate: "",
    isInternational: false,
    version_no: "V1",
    pg: "razorpay",
  };
  try {
    const response: AxiosResponse<ApiResponseGetSchoolDetails> = await api.post(
      "/get-school-by-code",
      {
        schoolCode: schoolCode,
      },
      {
        headers: {
          // Authorization:
          "Content-Type": "application/json",
        },
      }
    );
    console.log("Response for getting school by code = ", response);
    if (
      response &&
      response.data &&
      response.data.status_code === 200 &&
      response.data.data
    ) {
      schoolDetails = response.data.data;
    } else {
      throw new Error("Invalid Response");
    }
  } catch (err) {
    throw new Error(`Error getting school by code : ${err},`);
  }
  return schoolDetails;
};

export const fetchRecommendedItems = async (
  schoolCode: string
): Promise<DefaultAndRecommendedItem> => {
  let foundItems: DefaultAndRecommendedItem;
  try {
    const response: AxiosResponse<ApiResponseGetRecommendedItems> =
      await api.post(
        "/get-recommended-items-self-checkout",
        { schoolCode: schoolCode },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    console.log("Recommended items : Response = ", response);
    if (
      response &&
      response.status === 200 &&
      response.data &&
      response.data.status_code === 200 &&
      response.data.data
    ) {
      foundItems = response.data.data;
    } else {
      throw new Error("Invalid response for student search");
    }
  } catch (error) {
    foundItems = {
      default: {
        name: "",
        image: "",
        subtitle: "",
        description: "",
        base_price: 0,
        selling_price: 0,
        discountedBundlePrice: 0,
      },
      recommendedItems: [],
    };
    throw new Error(`API failed with error : ${error}`);
  }
  return foundItems;
};

export const getPaymentLinkForOrder = async (data: {
  orderNote: string;
}): Promise<AxiosResponse<ApiResponseGetPaymentLink>> => {
  //@ts-ignore
  let response: AxiosResponse<ApiResponseGetPaymentLink> = {
    status: 400,
    statusText: "Failed",
    data: {
      status: "Failed",
      status_code: 400,
      data: {
        orderID: "",
        links: [
          {
            href: "",
            rel: "",
            method: "",
          },
        ],
      },
      message: "",
    },
  };
  try {
    response = await axios.post(
      "https://streak-payments.el.r.appspot.com/nfo/get-payment-link-for-order",
      {
        ...data,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    console.log("Response = ", response);

    if (
      response &&
      response.status === 200 &&
      response.data &&
      response.data.status_code === 200 &&
      response.data.data
    ) {
      console.log("Successful Response", response);
    } else {
      throw new Error("Invalid response Get Payment Link");
    }
  } catch (error) {
    throw new Error(`API failed with error :${error} `);
  }
  return response;
};

export const getPastOrderCustomerData = async (): Promise<
  AxiosResponse<ApiResponseGetPastOrderCustomerData>
> => {
  //@ts-ignore
  let response: AxiosResponse<ApiResponseGetPastOrderCustomerData> = {
    status: 400,
    statusText: "Failed",
    data: {
      status: "Failed",
      status_code: 400,
      data: [],
      message: "",
    },
  };
  try {
    response = await axios.post(
      "https://streak-onboarding.el.r.appspot.com/nfo/get-past-students",
      {},
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    console.log("Response = ", response);

    if (
      response &&
      response.status === 200 &&
      response.data &&
      response.data.status_code === 200 &&
      response.data.data
    ) {
      console.log("Successful Response", response);
    } else {
      throw new Error("Invalid response Get Payment Link");
    }
  } catch (error) {
    throw new Error(`API failed with error :${error} `);
  }
  return response;
};
export const getAvailableDatesForExam = async (): Promise<
  AxiosResponse<getAvailableDatesForExamResponse>
> => {
  //@ts-ignore
  let response: AxiosResponse<getAvailableDatesForExamResponse> = {
    status: 400,
    statusText: "Failed",
    data: {
      status: "Failed",
      status_code: 400,
      data: [
        {
          schoolID: 0,
          examDate: "",
        },
      ],
      message: "",
    },
  };
  try {
    response = await axios.post(
      "https://streak-onboarding.el.r.appspot.com/nfo/get-dates-for-ir-school",
      {},
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    console.log("Response = ", response);

    if (
      response &&
      response.status === 200 &&
      response.data &&
      response.data.status_code === 200 &&
      response.data.data
    ) {
      console.log("Successful Response", response);
    } else {
      throw new Error("Invalid response Get Payment Link");
    }
  } catch (error) {
    throw new Error(`API failed with error :${error} `);
  }
  return response;
};

export function getOrderStatus(
  orderID: string
): Promise<getOrderStatusResponse> {
  return axios.post(
    "https://streak-payments.el.r.appspot.com/nfo/verify-payment-for-order",
    {
      orderID: orderID,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
}

export interface doNFOTransactionResponse {
  data: {
    orderID: string;
    links: [
      {
        href: string;
        rel: string;
        method: string;
      },
      {
        href: string;
        rel: string;
        method: string;
        parameters: {
          mercid: string;
          bdorderid: string;
          rdata: string;
        };
        valid_date: string;
        headers: {
          authorization: string;
        };
      }
    ];
  };
}

export interface doNFOTransactionResponseRazorpay {
  message: {
    amount: number;
    amount_due: number;
    amount_paid: number;
    attempts: number;
    created_at: number;
    currency: string;
    entity: string;
    id: string;
    notes: {
      choosenItemIDs: number[];
      email: string;
      grade: number;
      mobileNumber: string;
      name: string;
      referredBy: string | null;
      schoolID: number;
      schoolName: string;
    };
    offer_id: null;
    receipt: string;
    status: string;
  };
}

export function doNFOTransaction(
  name: string,
  schoolID: string,
  grade: number,
  mobileNumber: string,
  email: string,
  choosenItemIDs: number[],
  school: string,
  individualReg: boolean,
  referredBy?: string | null,
  couponCode?: string
): Promise<doNFOTransactionResponse> {
  return axios.post(
    "https://streak-payments.el.r.appspot.com/nfo/nfo-payment-link",
    individualReg
      ? referredBy
        ? {
            name: name,
            schoolID: schoolID,
            grade: grade,
            mobileNumber: mobileNumber,
            email: email,
            choosenItemIDs: choosenItemIDs,
            schoolName: school,
            referredBy: referredBy ? referredBy : null,
            ...(couponCode && { couponCode: couponCode }),
          }
        : {
            name: name,
            schoolID: schoolID,
            grade: grade,
            mobileNumber: mobileNumber,
            email: email,
            choosenItemIDs: choosenItemIDs,
            schoolName: school,
            ...(couponCode && { couponCode: couponCode }),
          }
      : {
          name: name,
          schoolID: schoolID,
          grade: grade,
          mobileNumber: mobileNumber,
          email: email,
          choosenItemIDs: choosenItemIDs,
          ...(couponCode && { couponCode: couponCode }),
        },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
}

export function doNFOTransactionRazorpay(
  name: string,
  schoolID: string,
  grade: number,
  mobileNumber: string,
  email: string,
  choosenItemIDs: number[],
  school: string,
  individualReg: boolean,
  referredBy?: string | null,
  couponCode?: string
): Promise<doNFOTransactionResponseRazorpay> {
  return axios.post(
    "https://streak-onboarding.el.r.appspot.com/nfo/create-selfcheckout-order",
    individualReg
      ? referredBy
        ? {
            name: name,
            schoolID: schoolID,
            grade: grade,
            mobileNumber: mobileNumber,
            email: email,
            choosenItemIDs: choosenItemIDs,
            schoolName: school,
            referredBy: referredBy ? referredBy : null,
            ...(couponCode && { couponCode: couponCode }),
          }
        : {
            name: name,
            schoolID: schoolID,
            grade: grade,
            mobileNumber: mobileNumber,
            email: email,
            choosenItemIDs: choosenItemIDs,
            schoolName: school,
            ...(couponCode && { couponCode: couponCode }),
          }
      : {
          name: name,
          schoolID: schoolID,
          grade: grade,
          mobileNumber: mobileNumber,
          email: email,
          choosenItemIDs: choosenItemIDs,
          ...(couponCode && { couponCode: couponCode }),
        },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
}

export function verifyNFOTransaction(
  orderID: string
): Promise<doNFOTransactionResponse> {
  return axios.post(
    "https://streak-payments.el.r.appspot.com/nfo/verify-payment-checkout",
    {
      orderID: orderID,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
}

export interface verifyNFOTransactionResponseRazorpay {
  status: "Success" | "Error";
  status_code: 200;
  data: {
    id: string;
    entity: string;
    amount: number;
    amount_paid: number;
    amount_due: number;
    currency: string;
    receipt: string;
    offer_id: null;
    status: "paid" | "attempted" | "created";
    attempts: number;
    notes: {
      name: string;
      email: string;
      grade: number;
      schoolID: number;
      referredBy: string | null;
      schoolName: string;
      mobileNumber: string;
      choosenItemIDs: number[];
    };
    created_at: number;
  };
  message: "";
}

export function verifyNFOTransactionRazorpay(
  orderID: string
): Promise<verifyNFOTransactionResponseRazorpay> {
  return axios
    .post(
      "https://streak-onboarding.el.r.appspot.com/nfo/razorpay-verify-payment",
      {
        orderID: orderID,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
    .then(
      (response: AxiosResponse<verifyNFOTransactionResponseRazorpay>) =>
        response.data
    ); // Return only the data;
}
export function razorpaySaveDetails(
  razorpay_payment_id: string,
  razorpay_order_id: string,
  razorpay_signature: string
): Promise<verifyNFOTransactionResponseRazorpay> {
  return axios
    .post(
      "https://streak-onboarding.el.r.appspot.com/nfo/razorpay-save-details",
      {
        razorpay_payment_id: razorpay_payment_id,
        razorpay_order_id: razorpay_order_id,
        razorpay_signature: razorpay_signature,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
    .then(
      (response: AxiosResponse<verifyNFOTransactionResponseRazorpay>) =>
        response.data
    ); // Return only the data;
}

interface nfoFecthUserNameResponse {
  status: "Success" | "Error";
  status_code: 200;
  data: {
    studentUsername: string;
  };
  message: "";
}

export function nfoFetchUserName(
  orderID: string
): Promise<nfoFecthUserNameResponse> {
  return axios
    .post(
      "https://streak-onboarding.el.r.appspot.com/nfo/fetch-username",
      {
        orderID: orderID,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
    .then((response: AxiosResponse<nfoFecthUserNameResponse>) => response.data); // Return only the data;
}

export interface Book {
  name: string;
  image: string;
  subtitle: string;
  description: string;
  link: string;
  base_price: number;
  selling_price: number;
  discountedBundlePrice: number;
  paid: boolean;
  id: number;
  schoolID: number;
  schoolName: string;
  showRecommendedItems?: boolean;
}

export interface nfoGetAvailableBooksResponse {
  status: "Success" | "Error";
  status_code: number;
  data: Book[];
  message: string;
}

export async function nfoGetAvailableBooks(): Promise<nfoGetAvailableBooksResponse> {
  try {
    // Check URL params directly first (for initial page load), then fallback to sessionStorage
    const urlParams = new URLSearchParams(window.location.search);
    let juniorGrade = urlParams.get("juniorGrade");
    let itemIdsStr = urlParams.get("item_ids");
    let bundleLanding = urlParams.get("bundleLanding");

    // Fallback to sessionStorage if not in URL params
    if (!juniorGrade) {
      juniorGrade = sessionStorage.getItem("juniorGrade");
    }
    if (!itemIdsStr) {
      itemIdsStr = sessionStorage.getItem("item_ids");
    }
    if (!bundleLanding) {
      bundleLanding = sessionStorage.getItem("bundleLanding");
    }

    const rawItemIds = itemIdsStr
      ? itemIdsStr
          .split(/[,-]/)
          .map((id) => id.trim())
          .filter(Boolean)
      : [];
    const parsedItemIds = rawItemIds
      .map((id) => parseInt(id, 10))
      .filter((id) => !isNaN(id));

    let requestBody: {
      juniorGrade?: boolean;
      bundleLandingPageExperiment?: boolean;
      itemID?: string;
    } = {};

    // Only add juniorGrade flag if:
    // 1. juniorGrade URL param exists (in URL or sessionStorage)
    // 2. itemIds include 10 or 11
    if (juniorGrade && parsedItemIds.length > 0) {
      if (parsedItemIds.includes(10) || parsedItemIds.includes(11)) {
        requestBody = { juniorGrade: true };
      }
    }

    const isBundleLanding =
      bundleLanding?.toLowerCase() === "true" || bundleLanding === "1";

    if (bundleLanding !== null) {
      sessionStorage.setItem(
        "bundleLanding",
        isBundleLanding ? "true" : "false"
      );
    }

    const primaryItemId = rawItemIds[0];

    if (isBundleLanding && primaryItemId) {
      requestBody = {
        ...requestBody,
        bundleLandingPageExperiment: true,
        itemID: primaryItemId,
      };
    }

    const response = await axios.post(
      "https://streak-payments.el.r.appspot.com/nfo/get-checkout-products-1",
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data; // Return only the data
  } catch (error) {
    throw new Error(`Failed to fetch available books: ${error}`);
  }
}

export interface getPaymentLinkCheckoutResponse {
  status: "Success" | "Error";
  status_code: number;
  data: {
    orderID: string;
    links: [
      {
        href: string;
        rel: string;
        method: string;
      },
      {
        href: string;
        rel: string;
        method: string;
        parameters: {
          mercid: string;
          bdorderid: string;
          rdata: string;
        };
        valid_date: string;
        headers: {
          authorization: string;
        };
      }
    ];
  };
  message: "";
}

export async function getPaymentLinkCheckout(data: {
  customerName: string;
  phone: string;
  email: string;
  address: string;
  pincode: string;
  city: string;
  state: string;
  items: string;
}): Promise<getPaymentLinkCheckoutResponse> {
  try {
    const response = await axios.post(
      "https://streak-payments.el.r.appspot.com/nfo/get-payment-link-checkout",
      {
        ...data,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data; // Return only the data
  } catch (error) {
    throw new Error(`Failed to get payment link: ${error}`);
  }
}

export interface getPaymentLinkCheckoutRazorpayResponse {
  status: "Success" | "Error";
  status_code: number;
  data: {
    amount: number;
    amount_due: number;
    amount_paid: number;
    attempts: number;
    created_at: number;
    currency: string;
    entity: string;
    id: string;
    notes: {
      purpose: string;
      receiptNo: string;
    };
    offer_id: null;
    receipt: string;
    status: string;
  };
  message: "";
}

export async function getPaymentLinkCheckoutRazorpay(data: {
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  address: string;
  pincode: string;
  city: string;
  state: string;
  items: string;
  paymentType: string; // "prepaid" // "cod"
  nfoSelected: boolean;
  schoolName?: string;
  grade?: number;
  schoolID?: number | null;
  giveBundleDiscount?: boolean;
  primaryProductID?: number;
  couponCode?: string;
  freeShippingExperiment?: boolean;
  channel?: string;
}): Promise<getPaymentLinkCheckoutRazorpayResponse> {
  const bundleLandingFlag = sessionStorage.getItem("bundleLanding");
  const isBundleLanding =
    bundleLandingFlag?.toLowerCase() === "true" || bundleLandingFlag === "1";
  const bundleExperimentPayload = isBundleLanding
    ? { bundleLandingPageExperiment: true }
    : {};
  try {
    const response = await axios.post(
      "https://streak-payments.el.r.appspot.com/nfo/get-payment-link-checkout-razorpay",
      {
        ...data,
        ...bundleExperimentPayload,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data; // Return only the data
  } catch (error) {
    throw new Error(`Failed to get payment link: ${error}`);
  }
}

interface verifyPaymentStatusRazorpayResponse {
  status: "Success" | "Error";
  status_code: number;
  data: {
    id: string;
    entity: string;
    amount: number;
    amount_paid: number;
    amount_due: number;
    currency: string;
    receipt: string;
    offer_id: null;
    status: string;
    attempts: number;
    notes: {
      purpose: string;
      receiptNo: string;
    };
    created_at: number;
  };
  message: "";
}

export async function verifyPaymentStatusRazorpay(
  orderID: string
): Promise<verifyPaymentStatusRazorpayResponse> {
  try {
    const response = await axios.post(
      "https://streak-payments.el.r.appspot.com/nfo/checkout-order-verify",
      {
        orderID: orderID,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data; // Return only the data
  } catch (error) {
    throw new Error(`Failed to get payment link: ${error}`);
  }
}

export interface sendOtpResponse {
  status: "Success" | "Error";
  status_code: number;
  data: {};
  message: "";
}

// Coupon Code Interfaces
export interface CouponCodeRequest {
  coupon_code: string;
  currentAmount: number;
}

export interface CouponCodeResponseData {
  coupon_code: string;
  discount_amount: number;
  priceAfterDiscount: number;
  priceBeforeDiscount: number;
}

export interface CouponCodeResponse {
  status: string;
  data: CouponCodeResponseData;
  message: string;
}

// Coupon API Function
export async function getCouponDiscount(
  couponCode: string,
  currentAmount: number
): Promise<CouponCodeResponse> {
  try {
    const response = await axios.post<CouponCodeResponse>(
      "https://streak-onboarding.el.r.appspot.com/nfo/get-discount-for-coupon-code",
      {
        coupon_code: couponCode,
        currentAmount: currentAmount,
        programType: "PFH",
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function sendOtpAPI(
  mobileNumber: string
): Promise<sendOtpResponse> {
  try {
    const response = await axios.post(
      "https://streak-onboarding.el.r.appspot.com/nfo/book-checkout-send-otp",
      {
        mobileNumber: mobileNumber,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data; // Return only the data
  } catch (error) {
    throw new Error(`Failed to get payment link: ${error}`);
  }
}
export interface verifyOtpResponse {
  status: "Success" | "Error";
  status_code: number;
  data: {};
  message: "";
}

export async function verifyOtpAPI(
  mobileNumber: string,
  otp: string
): Promise<verifyOtpResponse> {
  try {
    const response = await axios.post(
      "https://streak-onboarding.el.r.appspot.com/nfo/book-checkout-verify-otp",
      {
        mobileNumber: mobileNumber,
        otp: otp,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data; // Return only the data
  } catch (error) {
    throw new Error(`Failed to get payment link: ${error}`);
  }
}

export interface AddressFromPincodeResponse {
  status: "Success" | "Error";
  status_code: number;
  data: {
    state: string;
    city: string;
  };
  message: string;
}

export async function getAddressFromPincodeAPI(
  pincode: string
): Promise<AddressFromPincodeResponse> {
  try {
    const response = await axios.get(
      `https://streak-onboarding.el.r.appspot.com/lq/get-address-from-pincode?pincode=${pincode}`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(`Failed to get address from pincode: ${error}`);
  }
}

export interface CheckoutOptionsFromPincodeResponse {
  status: "Success" | "Error";
  status_code: number;
  data: {
    prepaid: boolean;
    cod: boolean;
  };
  message: string;
}

export async function getCheckoutOptionsFromPincodeAPI(
  pincode: string,
  phone: string
): Promise<CheckoutOptionsFromPincodeResponse> {
  try {
    const response = await axios.post(
      `https://streak-onboarding.el.r.appspot.com/nfo/book-checkout-payment-type`,
      {
        pincode: pincode,
        phone: phone,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(`Failed to get address from pincode: ${error}`);
  }
}

export interface OrderSummaryResponse {
  status: "Success" | "Error";
  status_code: number;
  data: {
    paymentType: string;
    shippingAddress: string;
    orderID: string;
    paymentMethod: string;
    firstName: string;
    lastName: string;
    phone: string;
    email: string;
    address: string;
    pincode: string;
    city: string;
    state: string;
    amountPaid: number;
    orderItems: string;
  };
  message: string;
}

export async function getOrderSummaryAPI(
  orderID: string
): Promise<OrderSummaryResponse> {
  try {
    const response = await axios.post(
      "https://streak-payments.el.r.appspot.com/nfo/checkout-order-summary",
      {
        orderID: orderID,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(`Failed to get order summary: ${error}`);
  }
}

export interface CustomerOrder {
  fist_name: string;
  last_name: string;
  phone: string;
  email: string;
  address: string;
  pincode: string;
  city: string;
  state: string;
  total_amount_paid: number;
  payment_type: string;
  payment_method: string;
  orderDate: string;
  products: string;
  item_ids: string[];
}
export interface PastOrdersResponse {
  status: "Success" | "Error";
  status_code: number;
  data: {
    orderedItemIDs: string[];
    customerOrders: CustomerOrder[];
  };
  message: string;
}

export async function getPastOrdersAPI(
  phoneNumber: string
): Promise<PastOrdersResponse> {
  try {
    const response = await axios.post(
      "https://streak-payments.el.r.appspot.com/nfo/get-past-orders",
      {
        phone: phoneNumber,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(`Failed to get past orders: ${error}`);
  }
}

export async function buttonClickTracker(
  eventName: string
): Promise<OrderSummaryResponse> {
  try {
    const response = await axios.post(
      "https://asia-south1-pythondjangoserver.cloudfunctions.net/button_click_tracker",
      {
        eventName: eventName,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(`Failed to get order summary: ${error}`);
  }
}
